export default "__VITE_ASSET__nWe4Mm_P__"